import { defineStore } from 'pinia';

export const usePattyStore = defineStore('patty', {
    state: () => ({
        activeTab: 'NEW',
        isPanelVisible: false,
        threadId: null,
        queryText: '',
    }),
    actions: {
        openNew() {
            /**
             * Open the messenger panel to the "New Message" tab
             */
            this.isPanelVisible = true;
            this.activeTab = 'NEW';
        },

        openHistory() {
            this.isPanelVisible = true;
            this.activeTab = 'HISTORY';
        },

        openThread(threadIdOrQueryText) {
            this.threadId = typeof threadIdOrQueryText == 'string' ? -1 : threadIdOrQueryText;
            this.queryText = typeof threadIdOrQueryText != 'string' ? '' : threadIdOrQueryText;
            this.isPanelVisible = true;
            this.activeTab = 'THREAD';
        },

        setQueryText(text) {
            this.queryText = text;
        },

        closePanel() {
            this.isPanelVisible = false;
        },
    },

    getters: {},
});
